module.exports = __webpack_public_path__ + "img/GH-kyujin-koukoku001.a68c5b5e.webp";